export function linksSection() {
  const linksBlock = $(".links-block");
  const expandBtn = linksBlock.find(".expand-btn");
  const isHome = $(".main").hasClass("home-page");
  let screenWidth = window.innerWidth;
  expandBtn.on("click", function () {
    let $this = $(this);
    screenWidth = window.innerWidth;
    if (isHome) {
      if (screenWidth < 1600) {
        $this.parents(".links-block").toggleClass("expanded").siblings().removeClass("expanded");
      }
    } else {
      if (screenWidth < 1024 ) {
        $this.parents(".links-block").toggleClass("expanded").siblings().removeClass("expanded");
      }
    }
    if(screenWidth < 768) {
      setTimeout(function (){
        $("html, body").animate({
          scrollTop: $this.offset().top - 65
        }, 700);
      }, 500);
    }
  });
  $(".footer-section").on("click", function (event) {
    if (screenWidth < 1600) {
      if (!$(event.target).closest(".links-section").length) {
        $(".links-block").removeClass("expanded");
      }
    }
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/linksSection.js